import { type FormItemProps, Input, type InputProps } from "antd";
import type { ReactNode } from "react";
import { FormItem } from "~components/Form/FormItem";
import { FormSkeleton } from "~components/Form/FormSkeleton";
type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;
  showSkeleton?: boolean;

  /** `disabled` moved out of `inputProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `InputProps` */
  inputProps?: Omit<InputProps, "disabled">;
};

export const FormInput = <TForm = unknown>({
  label,
  disabled,
  showSkeleton = false,
  inputProps,
  ...rest
}: Props<TForm>) => {
  const content = (
    <>
      {showSkeleton ? (
        <FormSkeleton label={label} />
      ) : (
        <FormItem<TForm> className="form-input-item" layout="vertical" label={label} {...rest}>
          <Input disabled={disabled} {...inputProps} />
        </FormItem>
      )}
    </>
  );

  return rest.hidden ? content : <div>{content}</div>;
};
